import { z } from 'zod';

import { TransactionPaymentMethod, TransactionStatus } from '__generated__/GQL';

import locales from './locales';

export const formSchema = z
  .object({
    afterDate: z.string().optional(),
    beforeDate: z.string().optional(),
    companyUserId: z.string().optional(),
    payin: z.boolean(),
    paymentMethod: z.array(z.nativeEnum(TransactionPaymentMethod)),
    payout: z.boolean(),
    status: z.array(z.nativeEnum(TransactionStatus)),
    valueGreaterThan: z.coerce.number().nullable(),
    valueLesserThan: z.coerce.number().nullable(),
    withoutReceipts: z.boolean(),
  })
  .refine(
    ({ valueGreaterThan, valueLesserThan }) => {
      if (!valueGreaterThan || !valueLesserThan) {
        return true;
      }

      return valueGreaterThan <= valueLesserThan;
    },
    {
      message: locales.errors.amounts,
      path: ['valueGreaterThan'],
    },
  );

export type SchemaOutput = z.infer<typeof formSchema>;
